<template>
  <div style="background: white" class="p-6 laptop:p-4 mobile:p-2">
    <div class="head flex justify-between">
      <div>
        <i class="el-icon-tickets" />
        <span class="pl-4" style="color: #82889c; font-size: 13px">
          {{ $t("menu.quantity") }}
        </span>
      </div>
      <div>
        <el-button v-if="link && shouldDisplayCertificates" size="small" type="primary" @click="handleQuantityClick">
          {{ $t("common.link") }}
        </el-button>
      </div>
    </div>
    <p style="font-size: 11px; padding-top: 10px; padding-bottom: 10px; color: red;" v-if="isMvpVesselPayActive">Billing
      will be automatically charged to barge company's credit card after barge signs a Certificate of Quantity</p>
    <div style="border-top: 1px solid #d5dded" class="mt-4"></div>
    <el-table :header-cell-style="isMobileScreen ? getMobileViewHeaderStyle : getHeaderStyle"
      :cell-style="isMobileScreen ? getMobileViewCellStyle : getCellStyle" :data="quantityTableData" style="width: 100%"
      @row-click="handlePdfClick">
      <el-table-column type="index" min-width="30" :label="$t('table.no')" />
      <el-table-column prop="originalName" label="File Name" align="left" min-width="90" />
      <el-table-column label="Signature Status" min-width="120">
        <template slot-scope="scope">
          <div v-if="scope.row.mvpDocId">
            <b v-if="scope.row.mvpDocIsSigned == 1">Signed</b>
            <b v-else>Require Signature From Barge</b>
          </div>
          <b v-else>Require Signature From JPUT</b>
        </template>
      </el-table-column>
      <el-table-column v-if="link" width="90">
        <template slot-scope="scope">
          <el-button :size="isMobileScreen ? 'mini' : 'small'" type="primary" plain
            @click="handleRemoveLinkClick(scope.row, scope.$index)">
            <span class="remove">{{ $t("btn.remove") }}</span>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="statusContainer mt-6 p-4" v-if="quantityTableData.length > 0">
      <div class="left flex-none w-30">Signature Status:</div>
      <div class="flex-grow flex flex-row">
        <div :class="[
          'flex flex-col',
          sign_type === 2 || sign_type === 3 ? 'active' : '',
        ]" style="flex: 0.5">
          <div class="flex justify-center items-center">
            <span class="label">Terminal </span>
            <svg-icon v-if="sign_type === 2 || sign_type === 3" iconClass="done" />
          </div>
          <div class="bar"></div>
        </div>
        <div :class="['flex flex-col', sign_type === 3 ? 'active' : '']" style="flex: 0.5; margin-left: 4px">
          <div class="flex justify-center items-center">
            <span class="label">Barge </span>
            <svg-icon v-if="sign_type === 3" iconClass="done" />
          </div>
          <div class="bar"></div>
        </div>
      </div>
    </div>
    <div class="head flex justify-between mt-12">
      <div>
        <i class="el-icon-tickets" />
        <span class="pl-4" style="color: #82889c; font-size: 13px">
          {{ $t("menu.quality") }}
        </span>
      </div>
      <el-button @click="handleQualityClick" v-if="link && shouldDisplayCertificates" size="small" type="primary">
        {{ $t("common.link") }}
      </el-button>
    </div>
    <div style="border-top: 1px solid #d5dded" class="mt-4"></div>
    <el-table :header-cell-style="isMobileScreen ? getMobileViewHeaderStyle : getHeaderStyle"
      :cell-style="isMobileScreen ? getMobileViewCellStyle : getCellStyle" :data="qualityTableData" style="width: 100%"
      @row-click="handlePdfClick">
      <el-table-column type="index" min-width="30" :label="$t('table.no')" />
      <el-table-column prop="originalName" label="File Name" align="left" min-width="80" />
      <el-table-column v-if="link" width="90">
        <template slot-scope="scope">
          <el-button :size="isMobileScreen ? 'mini' : 'small'" type="primary"
            @click="handleRemoveLinkClick(scope.row, scope.$index, 1)" plain>
            <span class="remove">{{ $t("btn.remove") }}</span>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="head flex justify-between mt-12">
      <div>
        <i class="el-icon-tickets" />
        <span class="pl-4" style="color: #82889c; font-size: 13px">
          {{ $t("menu.billOfLading") }}
        </span>
      </div>
      <div>
        <el-button v-if="link && shouldDisplayCertificates" size="small" type="primary"
          @click="handleBillOfLadingClick">
          {{ $t("common.link") }}
        </el-button>
      </div>
    </div>
    <p style="font-size: 11px; padding-top: 10px; padding-bottom: 10px; color: red;" v-if="isMvpVesselPayActive">Billing
      will be automatically charged to barge company's credit card after barge signs a Bill of Lading</p>
    <div style="border-top: 1px solid #d5dded" class="mt-4"></div>
    <el-table :header-cell-style="isMobileScreen ? getMobileViewHeaderStyle : getHeaderStyle"
      :cell-style="isMobileScreen ? getMobileViewCellStyle : getCellStyle" :data="billOfLadingTableData"
      style="width: 100%" @row-click="handlePdfClick">
      <el-table-column type="index" min-width="30" :label="$t('table.no')" />
      <el-table-column prop="originalName" label="File Name" align="left" min-width="90" />
      <el-table-column label="Signature Status" min-width="120">
        <template slot-scope="scope">
          <div v-if="scope.row.mvpDocId">
            <b v-if="scope.row.mvpDocIsSigned == 1">Signed</b>
            <b v-else>Require Signature From Barge</b>
          </div>
          <b v-else>Require Signature From JPUT</b>
        </template>
      </el-table-column>
      <el-table-column v-if="link" width="90">
        <template slot-scope="scope">
          <el-button :size="isMobileScreen ? 'mini' : 'small'" type="primary" plain
            @click="handleRemoveLinkClick(scope.row, scope.$index, 2)">
            <span class="remove">{{ $t("btn.remove") }}</span>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="statusContainer mt-6 p-4" v-if="billOfLadingTableData.length > 0">
      <div class="left flex-none w-30">Signature Status:</div>
      <div class="flex-grow flex flex-row">
        <div :class="[
          'flex flex-col',
          sign_type === 2 || sign_type === 3 ? 'active' : '',
        ]" style="flex: 0.5">
          <div class="flex justify-center items-center">
            <span class="label">Terminal </span>
            <svg-icon v-if="sign_type === 2 || sign_type === 3" iconClass="done" />
          </div>
          <div class="bar"></div>
        </div>
        <div :class="['flex flex-col', sign_type === 3 ? 'active' : '']" style="flex: 0.5; margin-left: 4px">
          <div class="flex justify-center items-center">
            <span class="label">Barge </span>
            <svg-icon v-if="sign_type === 3" iconClass="done" />
          </div>
          <div class="bar"></div>
        </div>
      </div>
    </div>
    <el-dialog class="cqDialog" :width="isMobileScreen ? '95vw' : '90vw'" :visible.sync="dialogVisible"
      :title="coqDialogTitle">
      <div class="text-right pr-4">
        <el-button type="primary" @click="handleSaveClick" size="small">{{ $t("btn.save") }}</el-button>
      </div>

      <div class="flex h-full p-4" :gutter="isMobileScreen ? 20 : 10">
        <div style="flex: 0.4;overflow-y: auto;">
          <el-table stripe ref="multipleTable" :data="linkList" tooltip-effect="dark" style="width: 100%"
            v-loading="tableLoading" @selection-change="handleTableSelectionChange" @row-click="handleTableRowClick"
            :header-cell-style="isMobileScreen ? getMobileViewHeaderStyle : getHeaderStyle"
            :cell-style="isMobileScreen ? getMobileViewCellStyle : getCellStyle">
            <el-table-column type="selection" width="50"> </el-table-column>
            <el-table-column prop="originalName" :label="$t('common.FileName')" min-width="80" align="left">
            </el-table-column>
            <el-table-column prop="createTime" :label="$t('common.DateCreated')" show-overflow-tooltip min-width="120">
            </el-table-column>
          </el-table>
        </div>
        <div style="flex: 0.6;">
          <pdf-view style="padding: 10px; width: 100%; height: 100%; overflow-y: scroll;" :dialog="false"
            :pdfUrl="pdfViewSrc" v-model="pdfViewSrc" />
        </div>
      </div>

      <!-- <div class="flex h-full p-4" :gutter="isMobileScreen?20:10">
        <div style="flex: 0.4;overflow-y: auto;">
          <el-table
            :header-cell-style="isMobileScreen ? getMobileViewHeaderStyle : getHeaderStyle"
            :cell-style="isMobileScreen ? getMobileViewCellStyle : getCellStyle"
            :data="sdsTableData"
            style="width: 100%"
            @row-click="handlePdfClick"
          >
            <el-table-column type="index" min-width="30" :label="$t('table.no')" />
            <el-table-column
              prop="originalName"
              label="File Name"
              align="left"
              min-width="80"
            />
          </el-table>
        </div>
        <div style="flex: 0.6;">
          <pdf-view
            style="padding: 10px; width: 100%; height: 100%; overflow-y: scroll;"
            :dialog="false" 
            :pdfUrl="pdfViewSrc"
            v-model="pdfViewSrc"
          />
        </div>
      </div> -->
    </el-dialog>
    <div class="head flex justify-between mt-12">
      <div class="flex items-center">
        <i class="el-icon-tickets" />
        <span class="pl-4" style="color: #82889c; font-size: 13px">
          Manifest
        </span>
      </div>
      <div>
        <el-button v-if="link && shouldDisplayCertificates" size="small" type="primary" @click="handleManifestClick">
          Upload
        </el-button>
      </div>
    </div>
    <p style="font-size: 11px; padding-top: 10px; padding-bottom: 10px; color: red;" v-if="isMvpVesselPayActive">Billing
      will be automatically charged to vessel company's credit card after vessel signs a Manifest</p>
    <div style="border-top: 1px solid #d5dded" class="mt-4"></div>
    <el-table :header-cell-style="isMobileScreen ? getMobileViewHeaderStyle : getHeaderStyle"
      :cell-style="isMobileScreen ? getMobileViewCellStyle : getCellStyle" :data="manifestTableData" style="width: 100%"
      @row-click="handlePdfClick">
      <el-table-column type="index" min-width="30" :label="$t('table.no')" />
      <el-table-column prop="originalName" label="File Name" align="left" min-width="90" />
      <el-table-column label="Signature Status" min-width="120">
        <template slot-scope="scope">
          <div v-if="scope.row.mvpDocId">
            <b v-if="scope.row.mvpDocIsSigned == 1">Signed</b>
            <b v-else>Require Signature From Barge</b>
          </div>
          <b v-else>Require Signature From Barge</b>
        </template>
      </el-table-column>
      <el-table-column v-if="link" width="90">
        <template slot-scope="scope">
          <el-button :size="isMobileScreen ? 'mini' : 'small'" type="primary" plain
            @click="handleRemoveLinkClick(scope.row, scope.$index, 4)">
            <span class="remove">{{ $t("btn.remove") }}</span>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="statusContainer mt-6 p-4" v-if="manifestTableData.length > 0">
      <div class="left flex-none w-30">Signature Status:</div>
      <div class="flex-grow flex flex-row">
        <div :class="['flex flex-col', sign_type === 3 ? 'active' : '']" style="flex: 1; margin-left: 4px">
          <div class="flex justify-center items-center">
            <span class="label">Barge </span>
            <svg-icon v-if="sign_type === 3" iconClass="done" />
          </div>
          <div class="bar"></div>
        </div>
      </div>
    </div>
    <div class="head flex justify-between mt-12">
      <div class="flex items-center">
        <i class="el-icon-tickets" />
        <span class="pl-4" style="color: #82889c; font-size: 13px">
          Receipt of Shipping
        </span>
      </div>
      <div>
        <el-button v-if="link && shouldDisplayCertificates" size="small" type="primary" @click="handleShippingClick">
          Upload
        </el-button>
      </div>
    </div>
    <p style="font-size: 11px; padding-top: 10px; padding-bottom: 10px; color: red;" v-if="isMvpVesselPayActive">Billing
      will be automatically charged to vessel company's credit card after vessel signs a Receipt of Shipping</p>
    <div style="border-top: 1px solid #d5dded" class="mt-4"></div>
    <el-table :header-cell-style="isMobileScreen ? getMobileViewHeaderStyle : getHeaderStyle"
      :cell-style="isMobileScreen ? getMobileViewCellStyle : getCellStyle" :data="receiptOfShippingTableData"
      style="width: 100%" @row-click="handlePdfClick">
      <el-table-column type="index" min-width="30" :label="$t('table.no')" />
      <el-table-column prop="originalName" label="File Name" align="left" min-width="90" />
      <el-table-column label="Signature Status" min-width="120">
        <template slot-scope="scope">
          <div v-if="scope.row.mvpDocId">
            <b v-if="scope.row.mvpDocIsSigned == 1">Signed</b>
            <b v-else>Require Signature From Barge</b>
          </div>
          <b v-else>Require Signature From Barge</b>
        </template>
      </el-table-column>
      <el-table-column v-if="link" width="90">
        <template slot-scope="scope">
          <el-button :size="isMobileScreen ? 'mini' : 'small'" type="primary" plain
            @click="handleRemoveLinkClick(scope.row, scope.$index, 6)">
            <span class="remove">{{ $t("btn.remove") }}</span>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="statusContainer mt-6 p-4" v-if="receiptOfShippingTableData.length > 0">
      <div class="left flex-none w-30">Signature Status:</div>
      <div class="flex-grow flex flex-row">
        <div :class="['flex flex-col', sign_type === 3 ? 'active' : '']" style="flex: 1; margin-left: 4px">
          <div class="flex justify-center items-center">
            <span class="label">Barge </span>
            <svg-icon v-if="sign_type === 3" iconClass="done" />
          </div>
          <div class="bar"></div>
        </div>
      </div>
    </div>
    <div class="head flex justify-between mt-12">
      <div class="flex items-center">
        <i class="el-icon-tickets" />
        <span class="pl-4" style="color: #82889c; font-size: 13px">
          Receipt Of Samples
        </span>
      </div>
      <div>
        <el-button v-if="link && shouldDisplayCertificates" size="small" type="primary" @click="handleSamplesClick">
          Upload
        </el-button>
      </div>
    </div>
    <p style="font-size: 11px; padding-top: 10px; padding-bottom: 10px; color: red;" v-if="isMvpVesselPayActive">Billing
      will be automatically charged to vessel company's credit card after vessel signs a Receipt Of Samples</p>
    <div style="border-top: 1px solid #d5dded" class="mt-4"></div>
    <el-table :header-cell-style="isMobileScreen ? getMobileViewHeaderStyle : getHeaderStyle"
      :cell-style="isMobileScreen ? getMobileViewCellStyle : getCellStyle" :data="receiptOfSamplesTableData"
      style="width: 100%" @row-click="handlePdfClick">
      <el-table-column type="index" min-width="30" :label="$t('table.no')" />
      <el-table-column prop="originalName" label="File Name" align="left" min-width="90" />
      <el-table-column label="Signature Status" min-width="120">
        <template slot-scope="scope">
          <div v-if="scope.row.mvpDocId">
            <b v-if="scope.row.mvpDocIsSigned == 1">Signed</b>
            <b v-else>Require Signature From Barge</b>
          </div>
          <b v-else>Require Signature From Barge</b>
        </template>
      </el-table-column>
      <el-table-column v-if="link" width="90">
        <template slot-scope="scope">
          <el-button :size="isMobileScreen ? 'mini' : 'small'" type="primary" plain
            @click="handleRemoveLinkClick(scope.row, scope.$index, 5)">
            <span class="remove">{{ $t("btn.remove") }}</span>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="statusContainer mt-6 p-4" v-if="receiptOfSamplesTableData.length > 0">
      <div class="left flex-none w-30">Signature Status:</div>
      <div class="flex-grow flex flex-row">
        <div :class="['flex flex-col', sign_type === 3 ? 'active' : '']" style="flex: 1; margin-left: 4px">
          <div class="flex justify-center items-center">
            <span class="label">Barge </span>
            <svg-icon v-if="sign_type === 3" iconClass="done" />
          </div>
          <div class="bar"></div>
        </div>
      </div>
    </div>
    <div class="head flex justify-between mt-12">
      <div class="flex items-center">
        <i class="el-icon-tickets" />
        <span class="pl-4" style="color: #82889c; font-size: 13px">
          Certificate of Origin
        </span>
      </div>
      <div>
        <el-button v-if="link && shouldDisplayCertificates" size="small" type="primary" @click="handleOriClick">
          Upload
        </el-button>
      </div>
    </div>
    <p style="font-size: 11px; padding-top: 10px; padding-bottom: 10px; color: red;" v-if="isMvpVesselPayActive">Billing
      will be automatically charged to vessel company's credit card after vessel signs a Certificate of Origin</p>
    <div style="border-top: 1px solid #d5dded" class="mt-4"></div>
    <el-table :header-cell-style="isMobileScreen ? getMobileViewHeaderStyle : getHeaderStyle"
      :cell-style="isMobileScreen ? getMobileViewCellStyle : getCellStyle" :data="certOfOriTableData"
      style="width: 100%" @row-click="handlePdfClick">
      <el-table-column type="index" min-width="30" :label="$t('table.no')" />
      <el-table-column prop="originalName" label="File Name" align="left" min-width="90" />
      <el-table-column label="Signature Status" min-width="120">
        <template slot-scope="scope">
          <b v-if="sign_type === 2 || sign_type === 3">Signed</b>
          <b v-else>Require Signature From JPUT</b>
        </template>
      </el-table-column>
      <el-table-column v-if="link" width="90">
        <template slot-scope="scope">
          <el-button :size="isMobileScreen ? 'mini' : 'small'" type="primary" plain
            @click="handleRemoveLinkClick(scope.row, scope.$index, 3)">
            <span class="remove">{{ $t("btn.remove") }}</span>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="statusContainer mt-6 mb-12 p-4" v-if="certOfOriTableData.length > 0">
      <div class="left flex-none w-30">Signature Status:</div>
      <div class="flex-grow flex flex-row">
        <div :class="[
          'flex flex-col',
          sign_type === 2 || sign_type === 3 ? 'active' : '',
        ]" style="flex: 1">
          <div class="flex justify-center items-center">
            <span class="label">Terminal </span>
            <svg-icon v-if="sign_type === 2 || sign_type === 3" iconClass="done" />
          </div>
          <div class="bar"></div>
        </div>
      </div>
    </div>
    <el-dialog class="uploadDialog" :title="coqDialogTitle" :visible.sync="showAttachmentDialog" width="500px"
      :close-on-click-modal="false">
      <div class="drag-drop-area" @dragover.prevent.stop="handleDragOver" @drop.prevent.stop="handleDrop"
        @dragenter.prevent.stop
        style="border: 2px dashed #ccc; padding: 20px; text-align: center; cursor: pointer; height: 150px; border-radius: 20px;">
        <p>Drag and drop your PDF file here</p>
        <p>or</p>
        <el-button size="small" type="primary" @click="triggerAttachmentFileUpload">Select File</el-button>
        <input type="file" id="attachment-upload-dialog" accept=".pdf" multiple style="display: none;"
          @change="handleAttachmentSelect" />
      </div>
    </el-dialog>


    <div class="head flex justify-between mt-4">
      <div>
        <i class="el-icon-tickets" />
        <span class="pl-4" style="color: #82889c; font-size: 13px">
          {{ $t("menu.sds") }}
        </span>
      </div>
    </div>
    <div style="border-top: 1px solid #d5dded" class="mt-4"></div>
    <el-table :data="sdsTableData" :header-cell-style="isMobileScreen ? getMobileViewHeaderStyle : getHeaderStyle"
      :cell-style="isMobileScreen ? getMobileViewCellStyle : getCellStyle" style="width: 100%"
      @row-click="handlePdfClick">
      <el-table-column type="index" min-width="30" :label="$t('table.no')" />
      <el-table-column prop="originalFileName" label="File Name" align="left" min-width="80" />
    </el-table>
    <no-data v-if="sdsTableData.length === 0" />
    <pdf-view v-if="operationData.src" :title="pdfViewTitle" :pdfUrl="operationData.src" v-model="showPdfView" />
  </div>
</template>

<script>
import PdfView from "@/components/common/pdf-view.vue";
import {
  addBoatLink,
  boatListFile,
  getCoqList,
  deleteBoatFile,
  getCQList,
  getBlList,
  getSdsFileByNomId,
  uploadOtherFile
} from "@/services";
import { mapState } from "vuex";
import SvgIcon from "@/components/SvgIcon.vue";
import { getCellStyle, getMobileViewCellStyle, getMobileViewHeaderStyle, getHeaderStyle } from "@/utils/getCellStyle";
import message from "@/locale/message";
import { uploadBl, uploadCq } from "@/services/form";
export default {
  props: {
    // 驳船订单id
    bid: {
      default: null,
    },
    // link状态
    statu: {
      type: Number,
      default: 1,
    },
    // 签名类型
    sign_type: {
      type: Number,
      default: null,
    },
    nominationData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      billOfLadingTableData: [],
      quantityTableData: [],
      qualityTableData: [],
      multipleSelection: [],
      dialogVisible: false,
      coqDialogTitle: 'Link Certificates',
      linkCoqList: [],
      linkCqlist: [],
      linkBlList: [],
      pdfViewSrc: "",
      // 0->coq 1->cq 2->bl
      linkType: 0,
      selection: [],
      linkList: [],
      link: false,
      showPdfView: false,
      operationData: {
        src: "",
      },
      tableLoading: true,
      sdsTableData: [],
      showAttachmentDialog: false,
      dragActive: false,
      selectedAttachment: null,
      manifestTableData: [],
      receiptOfShippingTableData: [],
      receiptOfSamplesTableData: [],
      certOfOriTableData: [],
    };
  },
  components: { PdfView, SvgIcon },
  computed: {
    ...mapState(["userInfo", "screenType"]),
    ...mapState(["mvpVesselPayFlag"]),
    shouldDisplayCertificates() {
      return process.env.VUE_APP_SHOW_CERTIFICATES == "true" || process.env.VUE_APP_SHOW_CERTIFICATES === true;
    },
    isMvpVesselPayActive() {
      return this.mvpVesselPayFlag == '0';
    },
    isMobileScreen() {
      return this.screenType?.isMobileScreen ?? false;
    },
  },
  watch: {
    bid(val) {
      if (!isNaN(val)) {
        this.getLinkList();
        this.getBoatListFile();
      }
    },
    sign_type: {
      handler() {
        if (
          (this.sign_type == 1 || this.sign_type == 0 || this.sign_type == null) &&
          (this.isLeader() || this.isCCR())
        ) {
          this.link = true;
        }
        if (this.sign_type == 2 || this.sign_type == 3) {
          this.link = false;
        }
      },
      immediate: true,
    },
    quantityTableData: {
      handler() {
        this.$emit("lists");
      },
    },
    qualityTableData: {
      handler() {
        this.$emit("lists");
      },
    },
    billOfLadingTableData: {
      handler() {
        this.$emit("lists");
      },
    },
    manifestTableData: {
      handler() {
        this.$emit("lists");
      },
    },
    receiptOfShippingTableData: {
      handler() {
        this.$emit("lists");
      }
    },
    receiptOfSamplesTableData: {
      handler() {
        this.$emit("lists");
      }
    },
    certOfOriTableData: {
      handler() {
        this.$emit("lists");
      }
    }
  },
  created() {
    if (!isNaN(this.bid)) {
      this.getLinkList();
      this.getBoatListFile();
    }
    this.$emit("lists");
  },
  mounted() {
    // console.log( 'userInfo:', this.userInfo )
  },
  methods: {
    getMobileViewHeaderStyle,
    getHeaderStyle,
    getCellStyle,
    getMobileViewCellStyle,
    handlePdfClick(item, row, event) {
      let target = event.target;
      if (target.tagName === "BUTTON" || target.classList.contains("remove"))
        return;

      this.operationData = {
        src: process.env.VUE_APP_BASE_API + item.url,
      };

      // Determine the type of document clicked based on the table data
      if (this.quantityTableData.includes(item)) {
        this.pdfViewTitle = "Certificate of Quantity";
      } else if (this.qualityTableData.includes(item)) {
        this.pdfViewTitle = "Certificate of Quality";
      } else if (this.billOfLadingTableData.includes(item)) {
        this.pdfViewTitle = "Bill of Lading";
      } else if (this.sdsTableData.includes(item)) {
        this.pdfViewTitle = "SDS Certificate";
      } else {
        this.pdfViewTitle = this.$t("ifm.ViewCertificate");
      }

      this.showPdfView = true;
    },
    // getCellStyle({ rowIndex }) {
    //   if (rowIndex % 2 === 1) {
    //     return {
    //       backgroundColor: "rgba(255,255,255,0.2)",
    //     };
    //   } else {
    //     return {
    //       backgroundColor: "rgba(228,228,228,0.2)",
    //     };
    //   }
    // },
    handleSaveClick() {
      // coq 上传附件
      if (!this.selection.length) return;

      let data = this.selection.map((item) => {
        return {
          bid: this.bid,
          type: this.linkType,
          pid: item.id,
          originalName: item.originalName,
          url: item.url,
        };
      });
      addBoatLink(data).then(() => {
        this.dialogVisible = false;
        this.$message.success(this.$t("status.success"));
        this.getBoatListFile();
      });
    },
    getBoatListFile() {
      if (!this.bid) return;

      boatListFile({ BId: this.bid, pageNum: 1, pageSize: 20 }).then((res) => {
        this.quantityTableData = res.rows.filter(row => row["type"] === 0);
        this.qualityTableData = res.rows.filter(row => row["type"] === 1);
        this.billOfLadingTableData = res.rows.filter(row => row["type"] === 2);
        this.certOfOriTableData = res.rows.filter(row => row["type"] === 3);
        this.manifestTableData = res.rows.filter(row => row["type"] === 4);
        this.receiptOfSamplesTableData = res.rows.filter(row => row["type"] === 5);
        this.receiptOfShippingTableData = res.rows.filter(row => row["type"] === 6);
      });


      // Separate call to get SDS
      getSdsFileByNomId(this.bid).then((res) => {
        if (res.data) {
          this.sdsTableData = res.data.map((item, index) => ({
            ...item,
            index: index + 1,
            originalName: item.originalName,
            url: item.documentUrl
          }));
          // this.sdsTableData = [{
          //   ...res.data,
          //   index: 1,
          //   originalName: res.data.originalFileName,
          //   url: res.data.documentUrl
          // }];
        } else {
          this.sdsTableData = [];
        }
      }).catch(() => {
        this.sdsTableData = [];
      });
    },
    getLinkList(type = 0) {
      if (!this.bid) return;
      getCoqList({ id: this.bid, status: 0 }).then((res) => {
        this.linkCoqList = this.handleUrl(res.rows);
        if (type === 0) {
          this.linkList = this.linkCoqList.slice();
          this.tableLoading = false;
        }
      });
      getCQList(this.bid).then((res) => {
        this.linkCqList = this.handleUrl(res.data);
        if (type === 1) {
          this.linkList = this.linkCqList.slice();
          this.tableLoading = false;
        }
      });
      getBlList({ id: this.bid, status: 0 }).then((res) => {
        this.linkBlList = this.handleUrl(res.rows);
        if (type === 2) {
          this.linkList = this.linkBlList.slice();
          this.tableLoading = false;
        }
      })

      if (this.statu == 4) {
        this.link = false;
      }
      if (
        (this.sign_type == 1 || this.sign_type == 0 || this.sign_type == null) &&
        (this.isLeader() || this.isCCR())
      ) {
        this.link = true;
      }
      if (this.sign_type == 2 || this.sign_type == 3) {
        this.link = false;
      }
    },
    isLeader() {
      return this.userInfo.userType == 1 && this.userInfo.role == 3
    },
    isCCR() {
      return this.userInfo.userType == 1 && this.userInfo.role == 2
    },
    handleTableSelectionChange(val) {
      this.selection = val;
      let last = this.selection[this.selection.length - 1];
      if (last) {
        this.pdfViewSrc = last.src;
      } else {
        this.pdfViewSrc = "";
      }
    },
    handleTableRowClick(row) {
      this.pdfViewSrc = row.src;
    },
    handleUrl(rows) {
      return rows.map((row) => {
        return { ...row, src: process.env.VUE_APP_BASE_API + row.url };
      });
    },
    handleQuantityClick() {
      this.linkType = 0;
      this.coqDialogTitle = "Certificate of Quantity";
      this.showAttachmentDialog = true;
    },
    handleQualityClick() {
      this.linkType = 1;
      this.pdfViewSrc = this.linkCqList[0]?.src;
      // this.linkList = this.linkCqList.slice();
      this.coqDialogTitle = this.$t('table.Lcoq')

      this.dialogVisible = true;
      this.getLinkList(1);
    },
    handleBillOfLadingClick() {
      this.linkType = 2;
      this.coqDialogTitle = "Bill of Lading";
      this.showAttachmentDialog = true;
    },
    handleRemoveLinkClick(item, index, type = 0) {
      deleteBoatFile(item.id).then(() => {
        this.$message.success(this.$t("status.success"));

        if (type == 0) this.quantityTableData.splice(index, 1);
        else if (type == 1) this.qualityTableData.splice(index, 1);
        else if (type == 2) this.billOfLadingTableData.splice(index, 1);
        else if (type == 3) this.certOfOriTableData.splice(index, 1);
        else if (type == 4) this.manifestTableData.splice(index, 1);
        else if (type == 5) this.receiptOfSamplesTableData.splice(index, 1);
        else if (type == 6) this.receiptOfShippingTableData.splice(index, 1);
      });
    },

    handleDragOver(event) {
      event.preventDefault();
      event.stopPropagation();
      this.dragActive = true;
    },

    handleDrop(event) {
      event.preventDefault();
      event.stopPropagation();
      this.dragActive = false;

      const files = Array.from(event.dataTransfer.files).filter(
        f => f.type === "application/pdf"
      );

      files.forEach(file => this.handleFile(file));
    },
    handleAttachmentSelect(event) {
      const files = Array.from(event.target.files);
      files.forEach(file => this.handleFile(file));
      event.target.value = "";
    },
    handleFile(file) {
      if (!file || file.type !== "application/pdf") {
        this.$message.warning("Please upload a valid PDF file.");
        return;
      }

      const formData = new FormData();
      formData.append("bId", this.bid);
      if (this.linkType == 0) {
        formData.append("file", file);
        uploadCq(formData)
          .then(() => {
            this.$message.success(this.$t("status.success"));
            this.showAttachmentDialog = false;
            this.getBoatListFile();
          })
          .catch(() => {
            this.$message.error("File upload failed.");
          });
      } else if (this.linkType == 2) {
        formData.append("file", file);
        uploadBl(formData)
          .then(() => {
            this.$message.success(this.$t("status.success"));
            this.showAttachmentDialog = false;
            this.getBoatListFile();
          })
          .catch(() => {
            this.$message.error("File upload failed.");
          });
      } else {
        formData.append("type", this.linkType);
        formData.append("files", file);
        uploadOtherFile(formData)
          .then(() => {
            this.$message.success(this.$t("status.success"));
            this.showAttachmentDialog = false;
            this.getBoatListFile();
          })
          .catch(() => {
            this.$message.error("File upload failed.");
          });
      }


    },

    handleManifestClick() {
      this.linkType = 4;
      this.coqDialogTitle = "Manifest";
      this.showAttachmentDialog = true;
    },
    handleShippingClick() {
      this.linkType = 6;
      this.coqDialogTitle = "Receipt of Shipping";
      this.showAttachmentDialog = true;
    },
    handleSamplesClick() {
      this.linkType = 5;
      this.coqDialogTitle = "Receipt of Samples";
      this.showAttachmentDialog = true;
    },
    handleOriClick() {
      this.linkType = 3;
      this.coqDialogTitle = "Certificate of Origin";
      this.showAttachmentDialog = true;
    },

    triggerAttachmentFileUpload() {
      document.getElementById("attachment-upload-dialog")?.click();
    },

  },
};
</script>

<style scoped lang="scss">
::v-deep .el-table::before {
  height: 0;
}

.Cerload {
  display: flex;
}

::v-deep .cqDialog .el-dialog {
  height: 80vh;
  display: flex;
  flex-direction: column;
  overflow: scroll;
}

::v-deep .cqDialog .el-dialog__wrapper {
  top: 0
}

::v-deep .uploadDialog .el-dialog {
  height: 32vh;
}

::v-deep .uploadDialog .el-dialog__body {
  overflow: auto;
}

.statusContainer {
  border: 1px solid #dfe1e7;

  .left {
    font-size: 12px;
    color: #82889c;
    font-weight: 600;
    line-height: 150%;
  }

  .active {
    .bar {
      background: #25cf36;
    }

    .label {
      color: #25cf36;
    }
  }

  .bar {
    height: 5px;
    background: #dedede;
  }

  .label {
    font-weight: 500;
    font-size: 13px;
    line-height: 26px;
    color: #dedede;
  }

  .svg-icon {
    width: 12px;
    height: 10px;
    margin-left: 5px;
  }
}

::v-deep .el-table__cell>.cell {
  padding-left: 3px;
  padding-right: 2px;

  b {
    word-break: keep-all;
  }
}

::v-deep th.el-table__cell>.cell {
  padding-left: 3px;
  padding-right: 1px;

  b {
    word-break: keep-all;
  }

}
</style>
